import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';

export function buildExtensions(placeholder: string) {
  return [
    StarterKit.configure({ heading: { levels: [2, 3] } }),
    Link.configure({
      openOnClick: false,
      autolink: true,
      protocols: ['https', 'mailto'],
      HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' },
    }),
    Placeholder.configure({ placeholder }),
  ];
}
